module.exports = __webpack_public_path__ + "portal-static/img/bm.0aababb4.png";